<template>
  <div id="toppage" ref="toppage">
    <!-- breadcrumb start-->
    <section class="breadcrumb breadcrumb_bg">
      <v-container class="container">
        <v-layout row class="row">
          <v-flex lg12>
            <div class="breadcrumb_iner">
              <div class="breadcrumb_iner_item">
                <h2 v-html="banner.slogan.en"></h2>
              </div>
              <div class="breadcrumb_iner_item text-right">
                <img class="w-300x" :src="banner.img" :alt="banner.alt">
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- breadcrumb start-->

    <!-- about part start-->
    <section class="about_part pt-10 pb-40">
      <v-container class="container">
        <v-layout row>
          <v-flex md12>
            <div class="about_text pr-90 pr-xs-0">
              <div class="experiance">
                <h4>
                  Daniel Wai Diabetes,
                  <br />Thyroid And Hormone Clinic Pte. Ltd.
                </h4>
              </div>
              <h4 class="mt-40 mb-0 mt-xs-0" v-if="getLang() == 'id'" v-html="about.subheader.id"></h4>
              <h4 class="mt-40 mb-0 mt-xs-0" v-else v-html="about.subheader.en"></h4>
              <p class="mt-10" v-if="getLang() == 'id'" v-html="about.desc.id"></p>
              <p class="mt-10" v-else v-html="about.desc.en"></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!-- about part end-->

    <!--================Blog Area =================-->
    <section id="notestop" class="blog_area single-post-area section_padding">
      <v-container class="container">
        <v-layout row wrap>
          <v-flex xs12 lg3>
            <div ref="notefiltertop" :class="'blog_right_sidebar ' + csstop" :style="elwidth">
              <aside class="hidden-md-and-down single_sidebar_widget post_category_widget">
                <h4 class="widget_title">Question</h4>
                <ul class="list cat-list">
                  <li v-for="(que, i) in doctornotes" :key="i" class="w-100">
                    <a @click="getnote(i)" class="d-flex">
                      <span v-html="gettwodigit(i+1)" class="mt-5 mr-10 font-11"></span>
                      <p v-html="que.header"></p>
                    </a>
                  </li>
                </ul>
              </aside>
              <v-select class="hidden-lg-and-up w-100 text-left bg-white" v-model="selectedselect" :items="getdistinctnoteheader" item-text="txt" item-value="id" @change="getnote(selectedselect)" label="Question" >
                <template slot="selection" scope="data">
                  <span class="pt-10" v-html="data.item.txt"></span>
                </template>
                <template slot="item" scope="data">
                  <p class="font-8" v-html="data.item.txt"></p>
                </template>
              </v-select>
            </div>
          </v-flex>
          <v-flex xs12 lg9 class="posts-list">
            <div ref="notetop" class="single-post">
              <div class="feature-img">
                <img class="img-fluid" :src="doctornotes[currentdoctornotesindex].img" alt />
              </div>
              <div class="blog_details p-20" :style="doctornotes[currentdoctornotesindex].bg">
                <h2 v-html="doctornotes[currentdoctornotesindex].header"></h2>
                <ul class="blog-info-link mt-3 mb-4">
                  <li>
                    <i class="far fa-user"></i> Dr. Daniel Wai
                  </li>
                </ul>
                <p class="excert" v-for="(parap, i) in doctornotes[currentdoctornotesindex].contents" :key="i" v-html="parap"></p>
                <div class="quote-wrapper" v-show="false">
                  <div class="quotes"></div>
                </div>
              </div>
            </div>
            <div class="navigation-top">
              <div class="navigation-area">
                <v-layout row>
                  <v-flex md6 lg6 class="nav-left flex-row d-flex justify-content-start align-items-center">
                    <a v-if="getprevnote() > -1" @click="getnote(getprevnote())">
                      <div class="thumb w-50">
                        <img class="img-fluid h-100" :src="doctornotes[0].img" alt />
                        <p class="color-white pl-10"><v-icon class="color-white">mdi-arrow-left-drop-circle-outline</v-icon> Previous</p>
                      </div>
                      <div class="detials">
                        <h4 v-html="doctornotes[0].header"></h4>
                      </div>
                    </a>
                  </v-flex>
                  <v-flex md6 lg6 class="nav-right flex-row d-flex justify-content-end align-items-center">
                    <a v-if="getnextnote() != ''" @click="getnote(getnextnote())">
                      <div class="detials">
                        <h4 v-html="doctornotes[getnextnote()].header"></h4>
                      </div>
                      <div class="thumb w-50 float-right">
                        <img class="img-fluid h-100" :src="doctornotes[getnextnote()].img" alt />
                        <p class="color-white pr-10">Next <v-icon class="color-white">mdi-arrow-right-drop-circle-outline</v-icon></p>
                      </div>
                    </a>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <!--================Blog Area end =================-->
  </div>
</template>

<script>
  import VueScrollTo from 'vue-scrollto';
  import { mapState, mapActions, mapMutations } from "vuex";

  export default {
    props: {
      language: String
    },
    data () {
      return {
        windowTop: 0,
        csstop: '',
        elwidth: 'width:100%;',
        currentdoctornotesindex: 0,
        selectedselect: '',
        banner: {
          img: require('@/assets/img/daniel_side.png'),
          alt: 'Dr. Daniel Wai',
          slogan: {
            en: 'Doctor\'s Notes',
            id: 'Doctor\'s Notes'
          }
        },
        about: {
          header: 'Daniel Wai Diabetes,<br />Thyroid And Hormone Clinic Pte. Ltd.',
          subheader: {
            en: 'Balance in the endocrine or hormone system is essential to our health.',
            id: 'Keseimbangan di endokrin dan sistem hormon ditubuh adalah sangat penting untuk kesehatan kita.'
          },
          desc: {
            en: 'Diseases occur when this balance is lost. We are committed to restore the body\'s nature balance for our patients.',
            id: 'Sakit penyakit bisa terjadi ketika keseimbangan sistem hormon ditubuh kita hilang. Kita berkomitmen untuk memulihkan keseimbangan natural tubuh untuk para pasien kita.'
          },
        },
        doctornotes:[
          {
            img: require('@/assets/img/notes/notes_001.png'),
            bg: 'background: white;',
            header: 'Eating healthily for patients with diabetes in Singapore: <span style="color:red;">Mission Impossible?</span>',
            contents: [
              'In diabetes, the blood sugar goes much higher than normal, and that causes damage to their kidneys, nerves, heart and brain. Most people understand that if one takes in a lot of sugar, their blood sugar will also rise. That is certainly correct. Therefore, avoid things that are very sweet. All deserts, like cakes, ice cream, local deserts like chendol, ice kacang, green bean soup, are very sweet as a lot of sugar is added so should be taken only rarely. For example, a can of cola has 39g (read: 8 tablespoons) of sugar! However, what patients may not realize is that when we take in starch like rice, bread, potatoes, prata, dahl and pasta, our body will convert the starch into sugar. A plate of fried rice and kopi has 66g of starch and 15g of sugar, and that is about the right amount of carbohydrates. That is because a typical 70kg man needs about 80g of carbohydrates per meal. However, if he drinks cola (for 39g) and eats chendol (for 44g) with his rice, the total starch and sugar will be a lot higher at 149g, and his blood sugar will be much higher as well.',
              'On top of the amount of carbohydrates, the type is also important. Healthy carbohydrates are those with lots of grains and fibre and thus digested slowly (low glycemic index). Examples are like wholemeal bread, brown rice, wheat based products like chapatti and pasta, and fresh fruits. Less healthy carbohydrates are those with no fibre and thus digested quickly (high glycemic index). Examples are soda, fruit juices, white bread, white rice and porridge. Less healthy carbohydrates are absorbed very quickly, causing a huge blood sugar spike and overwhelm the body’s ability to control it; healthy carbohydrates are digested and absorbed slowly, thus causing a much more gentler rice of blood sugar. The other benefit is that healthy carbohydrates contain lots of nutrients like vitamins. Lastly, the higher fibre and water content in healthy carbohydrates make us feel fuller and therefore we need to eat less of other things.',
              'One should also be wary of the phrase “no sugar added”. Even if no sugar is added, the manufacturer may have included so much sugar inside the drink that it is still very sweet. One well-known brand of apple juice in Singapore writes “no sugar added” prominently on each package of juice. However, a 250ml package of their apple juice contains 21g or 4 teaspoons of sugar. You are actually better drinking that glass of kopi (even with the condensed milk inside)!',
              'Around the region, lots of people like to eat crackers. They are called kerupuk or emping in Indonesia, keropok in Malaysia and 虾片 (prawn crackers) in Chinese. That is basically fried starch and is rather bad for diabetes: each piece of kerupuk contains 10g of starch, 6g of fat and 72kcal of energy. So 7 pieces of kerupuk contains as much starch as a plate of fried rice! The problem is that most people feel quite full with the rice, but not with the 7 pieces of kerupuk. So most people eat both the rice and the kerupuk, taking in far more than their requirements for carbohydrates. Patients with diabetes are therefore advised to minimize their intake of kerupuk. Western food that is equally bad would be potato chips and fries.',
              'A lot of Indonesians also like to use kecap manis or sweet sauce in their cooking, particularly when grilling chicken, beef, fish and when making tempeh (tempeh bacam). When I visit Indonesia, I find that I can only order 2 kinds of chicken: deep fried (ayam goreng) or grilled with sweet sauce (ayam panggang) . Patients with diabetes may want to use other flavorings like chili, garlic, onions to give food their favor, rather than just using the sweet sauce. On the other hand, one of the primary problem s of diabetes is obesity or being fat. Now insulin is the hormone that regulates blood sugar. Insulin lets sugar go into muscles to be stored or burned and liver and fat tissue for storage. When we overeat, our body becomes resistant to insulin. At first our body tries to overcome this by making more insulin, but gradually this fails and we develop diabetes. Weight loss has been well proven to improve insulin resistance and diabetes. To lose weight, eat a diet that is low in energy. So more soupy food, more fibres and wholegrain varieties.',
              'A lot of people may not realize that the regional flavored rice are all high in energy. Hainanese chicken rice is cooked with chicken soup; nasi lemak and nasi kuning are cooked in coconut oil; nasi briyani is first fried with ghee or oil, then steamed in chicken or mutton stock! White rice has much less energy, and brown rice is certainly even better.',
              'You can find out more about our local food at the Singapore Health Promotion Board website: <a href="http://www.hpb.gov.sg/hpb/ere/ere070101.asp" target="_blank">http://www.hpb.gov.sg/hpb/ere/ere070101.asp</a>. Alternatively, talk to your doctor about proper food choices.',
              'Exercise is excellent for diabetes. First it burns some energy while we are doing it. For example, half an hour of jogging or swimming burns about 250kcal. Second it increases our metabolic rate for 24 hours and thus helps burn energy even after the exercise. Third it reduces insulin resistance. Fortunately, exercise is for everyone, as even a leisurely walk is useful, especially if it is done daily.',
              'Last but not least, it is extremely important that you go and see your doctor regularly for your diabetes. As you may not feel anything even if the blood sugar is high, it is vital that you have blood tests to assess diabetes control. On top of that, cholesterol, blood pressure, urine protein, kidney and liver function, eye and foot screening and vaccination all need to be done by your doctor during those visits. Most patients with diabetes would need to take at least one medication; some more and some even need insulin injection. Do not stop any medication by yourself; always discuss with your doctor about your condition.',
              'With regular medication, some smart choices for food and some discipline to exercise, it is easy to control your diabetes.',
            ],
          },
          {
            img: require('@/assets/img/notes/notes_002.png'),
            bg: 'background: white;',
            header: 'Will taking too much medication for diabetes / high blood pressure / cholesterol harm my kidneys or liver?',
            contents: [
              'No it won’t.',
              'Before any medication is allowed to go on to the market, the medicine must be shown to have benefits (reduce blood pressure, blood sugar, cholesterol and/or prolong life) <b>and</b> does not cause any harm to the heart, liver and kidneys. Government organizations like the FDA and HSA in Singapore also monitors for new problems that are caused by medication. In this day of instant news and social media, these are often known by everyone immediately.',
              'A lot of my patients are told by their friends that taking the medication “for too long” will harm their kidneys and liver. That is not true. Studies in patients with diabetes such as the ADVANCE[1] and STENO-2 [2] had consistently shown that having better control of chronic diseases such as diabetes, high blood pressure and cholesterol are good for patients. These benefits extend over many years. The better the control of their illness (i.e. more medication they take), the lower the chance of heart attacks, strokes, eye problems, kidney problems, and premature death. On the other hand, when patients with diabetes do not take their medication as instructed by doctors, their control of diabetes, blood pressure and cholesterol worsened, leading to 58% more hospitalization and 81% increased chance of dying [3].',
              'With advances in medicine, we now have many effective types of medication allowing us to control chronic diseases much more effectively [4]. From year 1997 to 2006 in America, death in patients with diabetes dropped 23%, and death from heart attack and stroke dropped 40% [5].',
              'The evidence is overwhelming. Taking more medication did not lead to problems. In fact, the opposite is true.',
              'A lot of people may not realize that the regional flavored rice are all high in energy. Hainanese chicken rice is cooked with chicken soup; nasi lemak and nasi kuning are cooked in coconut oil; nasi briyani is first fried with ghee or oil, then steamed in chicken or mutton stock! White rice has much less energy, and brown rice is certainly even better.',
              'An important note: All medications have side effects and some are not suitable for patients with existing kidney and liver failure. So talk to your doctor for the best medication for you.',
              '1: ADVANCE Collaborative Group. Intensive Blood Glucose Control and Vascular Outcomes in Patients with Type 2 DiabetesN Engl J Med 2008;358:2560-72.',
              '2: Gaede et al. Multifactorial Intervention and Cardiovascular Disease in Patients with Type 2 DiabetesN Engl J Med 2003;348:383-93.',
              '3: Ho et al. Effect of Medication Nonadherence on Hospitalization and Mortality Among Patients With Diabetes Mellitus. Arch Intern Med. 2006;166:1836-1841',
              '4: Casagrande et al. The Prevalence of Meeting A1C, Blood Pressure, and LDL Goals Among People With Diabetes, 1988–2010. Diabetes Care. 2013 Feb 15. [Epub ahead of print]',
              '5: Gregg et al. Trends in Death Rates Among U.S. Adults With and Without Diabetes Between 1997 and 2006Diabetes Care 35:1252–1257, 2012',
            ],
          },
        ],
      }
    },
    created() {
      window.addEventListener('scroll', this.onScroll)
    },
    destroyed() {
      window.removeEventListener('scroll', this.onScroll);
    },
    components: {
    },
    methods: {
      onScroll() {
        this.windowTop = window.top.scrollY;
      },
      getLang() {
        this.language = this.$cookies.get('whatlang');
        return this.language;
      },
      gettwodigit(n) {
        return n > 9 ? "" + n: "0" + n;
      },
      getprevnote() {
        if (this.currentdoctornotesindex - 1 < 0) return -1;
        else return this.currentdoctornotesindex - 1;
        VueScrollTo.scrollTo('#notestop', "", "");
      },
      getnextnote() {
        if (this.currentdoctornotesindex + 1 >= this.doctornotes.length) return '';
        else return this.currentdoctornotesindex + 1;
        VueScrollTo.scrollTo('#notestop', "", "");
      },
      getnote(i) {
        if (i == '') this.currentdoctornotesindex = 0;
        else this.currentdoctornotesindex = i;
        VueScrollTo.scrollTo('#notestop', "", "");
      },
      ...mapActions([]),
      ...mapMutations(['set_vsnackbar_Show', 'set_vsnackbar_Msg']),
    },
    computed: {
      getdistinctnoteheader() {
        let returnarr = [];
        const newarr = [...new Set(this.doctornotes.map(note => note.header))];
        for (let i = 0; i < newarr.length; i++) {
          const nprop = {
            id: i,
            txt: newarr[i]
          }
          returnarr.push(nprop);
        }
        return returnarr
      },
      ...mapState({
      })
    },
    watch: {
      windowTop(val) {
        this.$nextTick(() => {
          if(this.$refs.notetop.getBoundingClientRect().top > 0) {
            if(this.$refs.notetop.getBoundingClientRect().top < 80) {
              this.csstop = 'dplay-fixed';
            } else {
              this.csstop = '';
              this.elwidth == 'width:100%;';
            }
          } 
          if (this.$refs.notefiltertop.clientWidth > 0) {
            if (this.elwidth == '' || this.elwidth == 'width:100%;') {
              this.elwidth = 'width:'+this.$refs.notefiltertop.clientWidth+'px';
            }
          }
        });
      }
    },
    mounted() {
    },
  }
</script>

<style>
</style>